import React, { useState } from 'react';
import { Grid, Menu } from 'antd';
import { FaCamera, FaCanadianMapleLeaf } from 'react-icons/fa';
import { VscGraphLine } from 'react-icons/vsc';
import { TbBrandWindy } from 'react-icons/tb';
import { GiWindsock } from 'react-icons/gi';

import './Weather.css';
import Camera from './Camera';
import useTempest from './Tempest';

function Weather({ db }) {
  const screen = Grid.useBreakpoint();
  const [menuTab, setMenuTab] = useState('0');

  const { flyable, tempestChart, tempestTable } = useTempest({ db });

  const camera = (
    <div id="camera-container" className="camera-container">
      <Camera id="camera" />
    </div>
  );

  const windy = (
    <iframe
      src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=wind&product=ecmwf&level=surface&lat=50.985&lon=-114.517&detailLat=51.18&detailLon=-114.47&detail=true"
      frameborder="0"
    ></iframe>
  );

  const rasp = (
    <iframe src="https://canadarasp.com/windgrams/index.htm?region=10&location=1&plotType=0" frameborder="0"></iframe>
  );

  const withContainer = (children, extraClassName) => {
    let className = 'container';
    if (extraClassName) className += ' ' + extraClassName;
    if (!screen.md) className += ' mobile';
    return <div className={className}>{children}</div>;
  };

  return (
    <div className="weather">
      <h1 className="page-title">Current Conditions</h1>
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          padding: '0.5em',
          backgroundColor: flyable[2],
          color: flyable[3],
          transition: 'all 0.35s',
        }}
      >
        <b>Flyable right now?</b> {flyable[1]}
      </div>
      <div className="content">
        {screen.md ? (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '40%' }}>{camera}</div>
            <div style={{ width: '60%', display: 'flex', flexDirection: 'column' }}>
              {withContainer(tempestTable)}
              {withContainer(tempestChart, 'no-pad')}
              {withContainer(windy)}
              {withContainer(rasp, 'wide tall')}
            </div>
          </div>
        ) : (
          <>
            <Menu
              mode="horizontal"
              style={{ width: '100%', justifyContent: 'center' }}
              selectedKeys={[menuTab]}
              onClick={(e) => setMenuTab(e.key)}
              items={[
                { key: '0', icon: <FaCamera style={{ fontSize: '1.75em' }} /> },
                { key: '1', icon: <GiWindsock style={{ fontSize: '1.75em' }} /> },
                { key: '2', icon: <VscGraphLine style={{ fontSize: '1.75em' }} /> },
                { key: '3', icon: <TbBrandWindy style={{ fontSize: '1.75em' }} /> },
                { key: '4', icon: <FaCanadianMapleLeaf style={{ fontSize: '1.75em' }} /> },
              ]}
            />
            {withContainer(camera, menuTab !== '0' && 'hidden')}
            {withContainer(tempestTable, menuTab !== '1' && 'hidden')}
            {withContainer(tempestChart, menuTab !== '2' ? 'hidden' : 'no-pad')}
            {menuTab === '3' && withContainer(windy)}
            {menuTab === '4' && withContainer(rasp, 'wide tall')}
          </>
        )}
      </div>
    </div>
  );
}

export default Weather;
